/* Halal King – theme-patch.js
   Loaded at end of <body> immediately AFTER theme.js.
   Overrides renderCategoryRow/renderBestSellers for tag-based Deli/Seasonal rows.
   Adds renderTagRow function. */
(function(){

  /* ── Tag-based row renderer ── */
  window.renderTagRow = function(rowId, tagName) {
    var row = document.getElementById(rowId);
    if (!row) return;
    var tagLower = tagName.toLowerCase();
    var items = (window.allProducts || []).filter(function(p) {
      return !p.isBulk && p.tags.some(function(t){ return t.toLowerCase() === tagLower; });
    }).slice(0, 24);
    if (!items.length) {
      var section = row.closest('.cat-row-section');
      if (section) section.style.display = 'none';
      return;
    }
    row.innerHTML = items.map(function(p) {
      var onSale = p.comparePrice && p.comparePrice > p.price;
      var thumb = p.image
        ? '<img class="cat-item-img" src="' + p.image + '" alt="' + p.name + '" loading="lazy">'
        : '<div class="cat-item-emoji">' + p.emoji + '</div>';
      var priceHtml = onSale
        ? '<span style="text-decoration:line-through;color:#999;font-size:.78rem">$' + p.comparePrice.toFixed(2) + '</span> <span class="cat-item-price on-sale">$' + p.price.toFixed(2) + '</span>'
        : '<span class="cat-item-price">$' + p.price.toFixed(2) + '</span>';
      var qty = (window.cartQtys && window.cartQtys[p.variantId]) || 0;
      var addCtrl = qty > 0
        ? '<div class="qty-mini" style="justify-content:center"><button onclick="event.stopPropagation();changeQty(' + p.variantId + ',-1)">−</button><span>' + qty + '</span><button onclick="event.stopPropagation();changeQty(' + p.variantId + ',1)">+</button></div>'
        : '<button class="add-btn" style="margin:0 auto;display:flex" onclick="event.stopPropagation();addToCart(' + p.variantId + ',this)" aria-label="Add to cart">+</button>';
      return '<div class="cat-item" onclick="openProduct(' + p.id + ')">'
        + thumb
        + '<div class="cat-item-name">' + p.name + '</div>'
        + '<div class="cat-item-foot">' + priceHtml + addCtrl + '</div>'
        + '</div>';
    }).join('');
  };

  /* ── Intercept renderCategoryRow: redirect Deli/Seasonal to tag-based ── */
  var _origCatRow = window.renderCategoryRow;
  window.renderCategoryRow = function(rowId, catFilter) {
    if (rowId === 'cannedRow') { window.renderTagRow('cannedRow', 'Deli'); return; }
    if (rowId === 'grainsRow') { window.renderTagRow('grainsRow', 'Seasonal'); return; }
    if (_origCatRow) _origCatRow.call(this, rowId, catFilter);
  };

  /* ── Best Sellers: tag-only, no category supplement ── */
  window.renderBestSellers = function() {
    var row  = document.getElementById('bestSellersRow');
    var wrap = document.getElementById('bestSellersWrap');
    if (!row) return;
    var items = (window.allProducts || []).filter(function(p){ return p.isBestSeller && !p.isBulk; });
    if (!items.length) { if (wrap) wrap.style.display = 'none'; return; }
    if (wrap) wrap.style.display = '';
    var cartQ = window.cartQtys || {};
    row.innerHTML = items.map(function(p) {
      var onSale = p.comparePrice && p.comparePrice > p.price;
      var thumb = p.image
        ? '<div class="bs-img-box"><img src="' + p.image + '" alt="' + p.name + '" loading="lazy"></div>'
        : '<div class="bs-emoji">' + p.emoji + '</div>';
      var priceHtml = onSale
        ? '<span class="p-was">$' + p.comparePrice.toFixed(2) + '</span><span class="p-price on-sale">$' + p.price.toFixed(2) + '</span>'
        : '<span class="p-price">$' + p.price.toFixed(2) + '</span>';
      var qty = cartQ[p.variantId] || 0;
      var addCtrl = qty > 0
        ? '<div class="qty-mini"><button onclick="event.stopPropagation();changeQty(' + p.variantId + ',-1)">−</button><span>' + qty + '</span><button onclick="event.stopPropagation();changeQty(' + p.variantId + ',1)">+</button></div>'
        : '<button class="add-btn" onclick="event.stopPropagation();addToCart(' + p.variantId + ',this)" aria-label="Add to cart">+</button>';
      return '<div class="bs-card" onclick="openProduct(' + p.id + ')">'
        + '<span class="bs-star-badge">⭐ Best Seller</span>'
        + thumb
        + '<div class="bs-name">' + p.name + '</div>'
        + '<div class="bs-foot">' + priceHtml + addCtrl + '</div>'
        + '</div>';
    }).join('');
  };

})();
